import React, { Component } from 'react';
import '../assets/custom.css';
import Header from "../HomeHeaderComponent/HomeHeader";
import Helpers from "../Shared/Helpers";
import REST from "../Shared/REST";
import TRACKING from "../Shared/DataTrackingPoints";
import ScoreBox from "../StudentsComponent/Maze1";
import {Modal} from "react-bootstrap";
import icon_twitter from "../assets/images/Twitter_Social_Icon.png";
import icon_fackbook from "../assets/images/Facebook_logo.png";

var logoDocs = require('../assets/images/ico_docs.png');
var logoVideo = require('../assets/images/ico_video.png');
var logoDevice = require('../assets/images/ico_audio.png');
var logoIdeasThatWork = require('../assets/images/logo_ideasthatwork.png');

class ResourcesLinkComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleClick = this.handleClick.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleClick(){
        this.setState({
                analytics: {
                    type: TRACKING.RESOURCES_DOWNLOAD,
                    metadata: {resourceId: this.props.value},
                }
            },
            ()=> this.handleAnalytics());
    }

    render(){
        let sameTab = this.props.sameTab;
        let target;
        if (sameTab){
            target="";
        }else{
            target="_blank";
        }
        return (
        <li>{this.props.download==="No"?<a onClick={this.handleClick}
               href={this.props.url} target={target} >{this.props.title}</a>:
            <a onClick={this.handleClick}
               href={this.props.url} target={target} download>{this.props.title}</a>}</li>
        )
    }
}

class VideoTutorialComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleClick = this.handleClick.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleClick(){
        this.setState({
                analytics: {
                    type: TRACKING.VIDEO_PLAY,
                    metadata: {videoId: this.props.id},
                }
            },
            ()=> this.handleAnalytics());
        this.props.handleOpenVideo(this.props.id, this.props.title, this.props.url);
    }

    render(){
        return (
            <li><a onClick={this.handleClick}>{this.props.title}</a></li>
        )
    }
}

export default class ResourcesComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVideo:false,
            videoURL:null,
            videoId: null,
            videoTitle:null
        };
        this.handleOpenVideo=this.handleOpenVideo.bind(this);
        this.handleCloseVideo=this.handleCloseVideo.bind(this);
    }

    handleOpenVideo(id, title, url){
        this.setState({
            showVideo:true,
            videoURL:url,
            videoId: id,
            videoTitle:title
        })
    }

    handleCloseVideo(){
        this.setState({
            showVideo:false,
            videoURL:null,
            videoId: null,
            videoTitle:null
        })
    }

    render(){
        return (
            <div>
                <Header currentItem = {"Resources"}/>

                <div className="clearfix"></div>

                <div className="section bgGreen">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>Here you’ll find all you need: From video tutorials to manuscripts and more!</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <h2><img src={logoDocs} alt="" border="0" className="ico-s" /> Getting Started</h2>
                                <ul className="listArrow">
                                    <ResourcesLinkComponent value={25} url={"https://docs.google.com/document/d/1tq1YlUUnuJJ7rkRWac7W1-nL-GyxujEnchIGj5YfQAE/"} title={"How to Log in, Create a Class and Add a Student"}/>
                                    <ResourcesLinkComponent value={13} url={"https://docs.google.com/document/d/1A88PHzgLpOFqDNfT2WSxRDCCrMf-objT1J0sgS67b94/edit?usp=sharing"} title={"Selecting apps -- quick lookup"}/>
                                    <ResourcesLinkComponent value={30} url={"https://docs.google.com/document/d/1nZqoGGYdv3Ba7CkvdbYSoYAboWa3bvwN-_NzLPysdQM/edit?usp=sharing"} title={"Add a Parent Account"}/>
                                    <ResourcesLinkComponent value={31} url={"https://docs.google.com/document/d/1Sx4IklA7n5YlxPyGHTPwb1GKIp4nR5lWBdvfCZEYzq8/edit?usp=sharing"} title={"Scoring"}/>
                                    <ResourcesLinkComponent value={32} url={"https://docs.google.com/document/d/1SU81DQjcqJkfexNCO3oVU_UpBRt13LD0EKSk3Wul-qo/edit?usp=sharing"} title={"Accessing the Data Charts: Overview"}/>
                                    <ResourcesLinkComponent value={33} url={"https://docs.google.com/document/d/1bq4Oxxgtvdu0IrFwV-5Y41Ayt6z1mLIR5lGxGneV1PI/edit?usp=sharing"} title={"Share a Student"}/>
                                    <ResourcesLinkComponent value={34} url={"https://docs.google.com/document/d/1Xd6_ICz6qymRfVI7_aF7PLIQ8JGa5tP2/edit#"} title={"Progression Rules"}/>
                                </ul>
                                <h2><img src={logoVideo} alt="" border="0" className="ico-s" /> Video Tutorials</h2>
                                <ul className="listArrow">
                                    <VideoTutorialComponent id={1} url={"https://www.youtube.com/embed/wy-KrJ_iRas?rel=0"} title={"Progress monitoring overview"} handleOpenVideo={this.handleOpenVideo}/>
                                </ul>
                            </div>
                            <div className="col-md-4">
                                <h2><img src={logoDevice} alt="" border="0" className="ico-s" /> Device Check</h2>
                                <ul className="listArrow">
                                    <ResourcesLinkComponent value={23} url={"./needs-assessment"} title={"Check your device for internet speed, webcam and microphone"} download={"No"} sameTab={true}/>
                                </ul>
                                <h2><img src={logoDocs} alt="" border="0" className="ico-s" /> Tech Docs</h2>
                                <ul className="listArrow">
                                    <ResourcesLinkComponent value={7} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/MonitoringProgressofStudentsWhoAreDeaforHardofHearing.pdf"} title={"Monitoring Progress for Students Who Are DHH"}/>
                                    <ResourcesLinkComponent value={8} url={"https://docs.google.com/document/d/1uE2ksBcVYHP0rVIUIxrfUupfK1NW4vOZH4kQJ1B6a68/edit"} title={"Children’s Online Privacy Protection Act (COPPA) statement"}/>
                                    <ResourcesLinkComponent value={9} url={"https://docs.google.com/document/d/1Et2sZWpNL_tZJzgvhI7LENaHIASxia9r/edit"} title={"Technical documentation for each of the apps"}/>
                                    <ResourcesLinkComponent value={35} url={"https://docs.google.com/document/d/1ljjANoXyYHSZ9rEAab1SjBnUf5Ifa3sB/edit"} title={"Technical Manual"}/>

                                </ul>

                            </div>
                            <div className="col-md-4">
                                <h2><img src={logoDocs} alt="" border="0" className="ico-s" /> Consent Forms</h2>
                                <ul className="listArrow">
                                    <ResourcesLinkComponent value={10} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/ActiveConsentForm.pdf"} title={"Active Consent form"}/>
                                    <ResourcesLinkComponent value={26} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_parents_Somali.pdf"} title={"Active consent form: Somali"}/>
                                    <ResourcesLinkComponent value={27} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_parents_Spanish.pdf"} title={"Active consent form: Spanish"}/>
                                    <ResourcesLinkComponent value={28} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_parents_Hmong.pdf"} title={"Active consent form: Hmong"}/>
                                    <ResourcesLinkComponent value={29} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/Consent_teachers_Spanish.pdf"} title={"Teachers consent form: Spanish"}/>
                                    <ResourcesLinkComponent value={11} url={"https://uploadbeta2025.s3.us-east-2.amazonaws.com/documents/AssentForm.pdf"} title={"Passive Consent form"}/>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal id={"videoBox"} show={this.state.showVideo} style={{top:100, left:-270}}>
                    <div className="modal-content" style={{width:620}}>
                        <div className="modal-header" style={{width:620}}>
                            <h4>{this.state.videoTitle}</h4>
                        </div>
                        <div className={"modal-body"}>
                            <iframe width="560" height="315" src={this.state.videoURL}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                        </div>
                        <div className="modal-footer">
                            <div style={{width: 100, marginLeft:'auto',marginRight:'auto'}}>
                                <a className="handBtn" onClick={this.handleCloseVideo} >
                                    <span>Close</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal>
                <footer className="bgGrey">
                    <div className="container">
                        <div className="row" style={{marginBottom:25}}>
                            <div className="col-sm-2" style={{textAlign:'left'}}>
                                <b>Follow us: </b>
                            </div>
                            <div className="col-sm-10" style={{textAlign:'left'}}>
                                <div style={{marginTop:1, marginLeft: -30}}>
                                    <a href={"https://twitter.com/AvenuePM"} style={{ textDecoration: 'none' }} target="_blank">
                                        <img src={icon_twitter} style={{width:28, height:28}} alt="" border="0" /> Twitter
                                    </a>
                                </div>
                                <div style={{marginLeft:95, marginTop:-28}} >
                                    <a href={"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline"} style={{ textDecoration: 'none' }} target="_blank">
                                        <img src={icon_fackbook} style={{width:28, height:28}} alt="" border="0" /> Facebook
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <p>This document was produced under U.S. Department of Education, Office of Special Education Programs Grant No. H327S170012. The views  expressed herein do not necessarily represent the positions or polices of the Department of Education. No official endorsement by the U.S. Department of Education of any product, commodity, service or enterprise mentioned in this publication is intended or should be inferred. This product is public domain.  Authorization to reproduce it in whole or in part is granted. While permission to reprint this publication is not necessary, the citation should be.</p>
                                <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the University of Minnesota and Penn State University.</p>
                                <img src={logoIdeasThatWork} alt="Logo - Ideas That Work. U.S. Office of Special Education Programs" border="0" />
                            </div>
                        </div>
                    </div>
                </footer>

            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./src/ResourcesComponent/Resources.js